import { matchRoutes } from 'umi';

export const dva = {
  config: {
    onError(err: ErrorEvent) {
      err.preventDefault();
      console.error(err.message);
    },
  },
};

export function onRouteChange({
  clientRoutes,
  location,
}: {
  clientRoutes: Array<{ path?: string; title?: string; routes?: unknown[] }>;
  location: { pathname: string };
}) {
  const matches = matchRoutes(clientRoutes, location.pathname);
  if (matches?.length) {
    // 取最深层匹配路由的 title（叶子路由优先）
    const route = [...matches].reverse().find((r) => r.route?.title);
    if (route?.route?.title) {
      document.title = route.route.title;
    }
  }
}
